/**
 * 👥 AdminPresenceIndicator - Индикатор подключения
 * 
 * Presence отключён для экономии ~9000 realtime запросов/день.
 * Показывает только статус подключения (Online/Connecting).
 */

import React from 'react';
import { useRealtime } from '@/contexts/RealtimeContext';
import { Badge } from '@/components/ui/badge';

interface AdminPresenceIndicatorProps {
  className?: string;
  maxAvatars?: number;
  showBadge?: boolean;
}

export const AdminPresenceIndicator: React.FC<AdminPresenceIndicatorProps> = () => {
  const { isConnected } = useRealtime();
  
  if (!isConnected) {
    return (
      <Badge variant="outline" className="gap-1.5 text-xs font-normal">
        <span className="animate-pulse h-2 w-2 rounded-full bg-yellow-500 inline-block" />
        Подключение...
      </Badge>
    );
  }
  
  return (
    <Badge variant="secondary" className="gap-1.5 text-xs font-normal">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
      </span>
      Онлайн
    </Badge>
  );
};

export default AdminPresenceIndicator;
